/**
 * @file index.ts
 *
 * @fileoverview Helper functions for organization search analytics events.
 */

import {
  DIMENSIONS,
  EventParameters,
  setEventParams,
} from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { Facet } from '~/jobiqo/models/search';
import { concatFacetsLabels } from '~/jobiqo/components/Search/facets/utils/facetHelpers';
import { concatArrayItems } from '~/jobiqo/utils/mapper';
import { ANONYMOUS_USER } from '~/jobiqo/lib/auth';
import { SearchApiJobResult } from '~/jobiqo/types/types';
import { getCustomOrganizationProfileSearchDimensions } from '~/jobiqo/components/Slots/customOrganizationProfileSearchDimensions';

export const getOrganizationSearchDimensions = (
  user: User | undefined,
  selectedFacets: Facet[],
  title: string,
  organizationProfiles: SearchApiJobResult,
  location: string,
  searchQuery?: string,
): EventParameters => {
  return setEventParams({
    [DIMENSIONS.entity_id]: organizationProfiles.pages
      ?.map((organization) => organization?.id ?? '')
      .join(' | '),
    [DIMENSIONS.entity_title]: title,
    [DIMENSIONS.occupations]: concatFacetsLabels(
      selectedFacets.filter(
        (facet) => facet.name === 'field_org_occupational_fields_parents_all',
      ),
    ),
    [DIMENSIONS.industry]: concatFacetsLabels(
      selectedFacets.filter((facet) => facet.name === 'field_org_industry'),
    ),
    [DIMENSIONS.fields_of_study]: concatFacetsLabels(
      selectedFacets.filter(
        (facet) => facet.name === 'field_org_field_of_studies_parents_all',
      ),
    ),
    [DIMENSIONS.regions]: location,
    [DIMENSIONS.search_query]: searchQuery,
    [DIMENSIONS.current_user_id]: user?.id,
    [DIMENSIONS.current_user_role]:
      concatArrayItems(user?.roles, 'targetId') ?? ANONYMOUS_USER,
    ...getCustomOrganizationProfileSearchDimensions(
      user,
      organizationProfiles,
      title,
      selectedFacets,
      location,
      searchQuery,
    ),
  });
};
